import type { ComponentProps } from 'react';

import { Input } from '../input';

export type DateInputProps = {
  value?: string;
  onChange?: (value?: string) => void;
} & Omit<ComponentProps<typeof Input>, 'value' | 'onChange' | 'type'>;

const DateInput = ({ value, onChange, ...props }: DateInputProps) => (
  <Input
    {...props}
    type="date"
    value={value?.slice(0, 10) ?? ''}
    onChange={e => onChange?.(e.target.value || undefined)}
  />
);

export { DateInput };
